export const availableYears = [2023, 2022, 2021, 2020, 2019, 2018];
export const DYNAMICS_RANGE = 4;
export const ENABLE_PARTNERSHIPS = Boolean(process.env.REACT_APP_ENABLE_PARTNERSHIPS);
export const ENABLE_REPORT_REQUESTS = Boolean(process.env.REACT_APP_ENABLE_REPORT_REQUESTS);
